import { Checkbox } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { MutingData } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import { useTranslation } from "react-i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type MutingNode = Node<InterfaceToRecord<MutingData & ExtraNodeData>>;

export default function Muting(props: NodeProps<MutingNode>): JSX.Element {
    const { t } = useTranslation();
    const [modeOne, setModeOne] = useState(props.data.modeOne ?? true);
    const [modeTwo, setModeTwo] = useState(props.data.modeTwo ?? true);
    const [modeThree, setModeThree] = useState(props.data.modeThree ?? true);

    const updateNode = useUpdateNodeData<MutingNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ modeOne, modeTwo, modeThree });
    }, [modeOne, modeTwo, modeThree, updateNode]);

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <Checkbox
                label={t("component.actionConfigNodes.muting.seatSensor")}
                checked={modeOne}
                onChange={(_e, checked) => setModeOne(checked!)}
            />
            <Checkbox
                label={t("component.actionConfigNodes.muting.longButtonPress")}
                checked={modeTwo}
                onChange={(_e, checked) => setModeTwo(checked!)}
            />
            <Checkbox
                label={t("component.actionConfigNodes.muting.shortButtonPress")}
                checked={modeThree}
                onChange={(_e, checked) => setModeThree(checked!)}
            />
        </ActionConfigNode>
    );
}
